<div class="main-container">
  <div class="ui middle aligned center aligned grid">
    <div class="login-container">
      <div class="login-content">
        <h1>Forgot Your Password?</h1>
        <p class="light">Enter your login email address below and we will send
          you an email with a link to reset your password.</p>

        <form class="login">
          <div class="field">
            <div class="label">Email Address</div>
            <app-text-input
              icon="mail"
              type="text"
              v-model="email"
              placeholder="Enter your e-mail address"
            />
          </div>

          <div class="field">
            <a class="ui fluid primary button" v-on:click="reset()">SEND RESET PASSWORD EMAIL</a>
          </div>
        </form>

        <hr>
        <p>Don't have an account? <router-link :to="{name: 'register'}"><a class="primary">Signup Now</a></router-link></p>
      </div>
    </div>
  </div>
</div>
